var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E3F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0123 45.7421L53.3072 26.0928C54.0597 25.3643 54.9871 25 56.0892 25C57.1914 25 58.1187 25.3643 58.8712 26.0928C59.6237 26.8214 60 27.7226 60 28.7964C60 29.8703 59.6237 30.7715 58.8712 31.5L35.8152 53.8427C35.0183 54.6142 34.084 55 33.0123 55C31.9405 55 31.0062 54.6142 30.2094 53.8427L21.1185 45.0411C20.3659 44.3125 19.9932 43.4113 20.0001 42.3374C20.0071 41.2636 20.3868 40.3624 21.1393 39.6339C21.8919 38.9053 22.8227 38.541 23.9318 38.541C25.0409 38.541 25.9717 38.9053 26.7242 39.6339L33.0123 45.7421Z",
    fill: "#006BD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.69364a55a2100c593303ae153119232d.svg";
export { ForwardRef as ReactComponent };